import {
  buildSuspensionSeries,
  detectSuspensionEvents,
  computeSuspensionMetrics,
} from './suspensionAnalysis';
import { runJackPackingAnalysisFromTelemetry } from './jackPackingEngine';
import { getJackParamsForAnalysis, buildTrimOverrideForRide, getTuningGuideConfig } from './jackSettings';
import { analyzeTuningGuide, buildOpenAiPayload } from './tuningKbAnalysis';
import {
  buildSummarySnapshot,
  SUMMARY_DEFAULT_TRAVEL_FRONT_MM,
  SUMMARY_DEFAULT_TRAVEL_REAR_MM,
} from './suspensionSummarySnapshot';
import { computeRoughnessFromTelemetry } from './roughnessScore';
import { getRoughnessCalibrationSync } from './roughnessCalibration';

/**
 * Jack + metrics + summary snapshot + tuning eval for one ride (compare or tooling).
 * @param {object[]} telemetryData
 * @param {object} ride — jackSuspensionParams, suspensionParams, analysisTrim
 */
export function computeCompareSuspensionBundle(telemetryData, ride) {
  const td = Array.isArray(telemetryData) ? telemetryData : [];
  const trim = buildTrimOverrideForRide(td, ride?.analysisTrim);
  const jackParams = getJackParamsForAnalysis({
    ...(ride?.jackSuspensionParams ?? ride?.suspensionParams ?? {}),
    ...trim,
  });
  const jackResult = runJackPackingAnalysisFromTelemetry(td, jackParams);
  const s = buildSuspensionSeries(td);
  const metrics = s ? computeSuspensionMetrics(s, detectSuspensionEvents(s)) : null;
  const cal = getRoughnessCalibrationSync();
  const roughness = computeRoughnessFromTelemetry(td, cal);
  const summarySnapshot = buildSummarySnapshot(jackResult, metrics, roughness.score);
  const jOk = jackResult?.ok === true;
  const ar = jOk ? jackResult.analysisResults : null;
  const stF = ar?.stats?.front ?? null;
  const stR = ar?.stats?.rear ?? null;
  const frontTravelMm =
    Number.isFinite(Number(ar?.params?.frontTravel)) && Number(ar.params.frontTravel) > 0
      ? Number(ar.params.frontTravel)
      : SUMMARY_DEFAULT_TRAVEL_FRONT_MM;
  const rearTravelMm =
    Number.isFinite(Number(ar?.params?.rearTravel)) && Number(ar.params.rearTravel) > 0
      ? Number(ar.params.rearTravel)
      : SUMMARY_DEFAULT_TRAVEL_REAR_MM;
  const ranges = getTuningGuideConfig();
  const tuningEval = analyzeTuningGuide(summarySnapshot, stF, stR, frontTravelMm, rearTravelMm, ranges);
  return {
    jackResult,
    metrics,
    summarySnapshot,
    stF,
    stR,
    frontTravelMm,
    rearTravelMm,
    tuningEval,
    openAiSlice: buildOpenAiPayload(
      summarySnapshot,
      stF,
      stR,
      frontTravelMm,
      rearTravelMm,
      tuningEval.kbBullets,
    ),
  };
}
